import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

export interface FeatureToolTipItem {
    ref: any;
    text: string;
}

@Injectable({
    providedIn: 'root'
})
export class FeatureTooltipService {
    public tooltips: Observable<Set<FeatureToolTipItem>>;

    private readonly _tooltips: BehaviorSubject<Set<FeatureToolTipItem>>;

    constructor() {
        this._tooltips = new BehaviorSubject<Set<FeatureToolTipItem>>(new Set<FeatureToolTipItem>());
        this.tooltips = this._tooltips.asObservable();
    }

    public addTooltip(item: FeatureToolTipItem): void {
        this._tooltips.next(this._tooltips.getValue().add(item));
    }

    public removeTooltip(item: FeatureToolTipItem): void {
        const tempSet = this._tooltips.getValue();
        tempSet.delete(item);
        this._tooltips.next(tempSet);
    }
}
